// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"ccc323789ceedec6","6831":"2c8247672fa27397","8503":"2d3bd5489d4a4f9d","9683":"83b61b4339f1e25c"}[chunkId] + ".js";
};